module.exports = __webpack_public_path__ + "static/media/cardFour.37f3f43e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Images/rowSix/cardFour.jpg
// module id = 86
// module chunks = 0